import React from 'react';
import { useUIStore } from '@/store/uiStore';
import CreateCategoryModal from './CreateCategoryModal';
import CategoryDetailModal from './CategoryDetailModal';
import EditCategoryModal from './EditCategoryModal';

interface CategoryModalsProps {
  onCreateSuccess?: () => void;
}

const CategoryModals: React.FC<CategoryModalsProps> = ({ onCreateSuccess }) => {
  const { modals, closeModal } = useUIStore();

  return (
    <>
      <CreateCategoryModal
        isOpen={modals.createCategory || false}
        onClose={() => closeModal('createCategory')}
        onSuccess={() => {
          // Refresh the category list without reloading the page
          onCreateSuccess?.();
          closeModal('createCategory');
        }}
      />
    </>
  );
};

export default CategoryModals;

// Export individual components
export {
  CreateCategoryModal,
  CategoryDetailModal,
  EditCategoryModal,
};

// Export other category components
export { default as CategoryHierarchyTree } from '../CategoryHierarchyTree';
export { default as CategorySelector } from '../CategorySelector';
export { default as ExportCategoryModal } from '../ExportCategoryModal';
